/* FUT7 — home (port da TNF v8): abas e setas das vitrines, nomes de clube pelo código, janela das ligas,
   busca de equipas, palavra animada da oferta, vídeos de clientes, FAQ e o clube do anúncio (?c=XXX).
   Nome de clube nunca sai do servidor: vem do mapa [data-f7-clubes] (snippets/f7-clubes, via f7-busca). Roda uma vez por página. */
(function(){
  if (window.__f7Home) return;
  window.__f7Home = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  var I18N = {};
  try { var ie = document.getElementById('f7-h-i18n'); if (ie) I18N = JSON.parse(ie.textContent); } catch(e){}
  function _t(k, v){ var s = I18N[k] || k; if (v) { for (var x in v) { s = s.split('{' + x + '}').join(v[x]); } } return s; }

  /* Mapa código -> nome no idioma da página (pt: n, outros: ne) */
  var TEAM = null;
  function teamMap(){
    if (TEAM) return TEAM;
    TEAM = {};
    var d = document.querySelector('[data-f7-clubes]');
    var pt = /^pt/i.test(document.documentElement.lang || '');
    try { (d ? JSON.parse(d.textContent) : []).forEach(function(c){ if (c && c.c && !TEAM[c.c]) TEAM[c.c] = pt ? c.n : (c.ne || c.n); }); } catch(e){}
    return TEAM;
  }
  function codeOf(handle){
    var map = teamMap(), parts = (handle || '').split('-');
    for (var i = parts.length - 1; i >= 0; i--) { if (/^[0-9]{3}$/.test(parts[i]) && map[parts[i]]) return parts[i]; }
    return '';
  }
  function nameCards(root){
    var map = teamMap();
    root.querySelectorAll('.f7-h-pcard').forEach(function(card){
      var t = card.querySelector('.f7-h-pcard__title');
      var club = map[card.dataset.code] || map[codeOf(card.dataset.handle)];
      if (t && club && t.textContent.indexOf(club) === -1) t.textContent = club + ' ' + t.textContent.trim();
    });
  }
  function initials(n){ return n.replace(/^(FC|AC|AS|RB|CF|SC|CA|SL)\s+/i, '').split(/[\s-]+/).filter(Boolean).map(function(w){ return w.charAt(0); }).join('').slice(0, 3).toUpperCase(); }
  function fillNames(root){
    var map = teamMap();
    root.querySelectorAll('[data-f7-h-club]').forEach(function(a){
      var n = map[a.dataset.f7HClub];
      if (!n) { a.hidden = true; return; }
      var s = a.querySelector('[data-f7-h-cname]'); if (s && !s.textContent) s.textContent = n;
      var m = a.querySelector('[data-f7-h-mono]'); if (m && !m.textContent) m.textContent = initials(n);
      a.dataset.name = n.toLowerCase();
      a.setAttribute('aria-label', n);
    });
    root.querySelectorAll('[data-f7-h-name-of]').forEach(function(s){ var n = map[s.dataset.f7HNameOf]; if (n && !s.textContent) s.textContent = n; });
  }
  function norm(s){ return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9 ]/g, '').trim(); }

  /* Setas sempre sobre o painel visível */
  function wireNav(box, current){
    var prev = box.querySelector('[data-f7-h-prev]'), next = box.querySelector('[data-f7-h-next]');
    if (!prev || !next) return function(){};
    var upd = function(){
      var t = current(); if (!t) return;
      prev.disabled = t.scrollLeft < 4;
      next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4;
    };
    var step = function(dir){ var t = current(); if (t) t.scrollBy({left: dir * t.clientWidth * 0.9, behavior: reduce ? 'auto' : 'smooth'}); };
    prev.addEventListener('click', function(){ step(-1); });
    next.addEventListener('click', function(){ step(1); });
    box.querySelectorAll('[data-f7-h-panel]').forEach(function(p){ p.addEventListener('scroll', upd, {passive: true}); });
    window.addEventListener('resize', upd);
    upd();
    return upd;
  }

  function tabs(sec, onChange){
    var chips = sec.querySelectorAll('[data-tab]');
    var panels = sec.querySelectorAll('[data-f7-h-panel]');
    var select = function(chip){
      var i = +chip.dataset.tab;
      chips.forEach(function(c){ var on = c === chip; c.classList.toggle('is-active', on); c.setAttribute('aria-selected', on ? 'true' : 'false'); });
      panels.forEach(function(p, n){ p.hidden = n !== i; if (n === i) p.scrollLeft = 0; });
      if (onChange) onChange(i, chip);
    };
    chips.forEach(function(chip){ chip.addEventListener('click', function(){ select(chip); }); });
    return select;
  }

  /* Vitrines; a primeira com data-f7-h-ad recebe o clube do anúncio (?c=XXX) */
  function rails(code){
    document.querySelectorAll('[data-f7-h-tabs]').forEach(function(sec){
      nameCards(sec);
      var cur = 0;
      var upd = wireNav(sec, function(){ return sec.querySelectorAll('[data-f7-h-panel]')[cur]; });
      var all = sec.querySelector('[data-f7-h-tab-all]');
      var select = tabs(sec, function(i, chip){
        cur = i;
        if (all && chip.dataset.url) { all.href = chip.dataset.url; all.querySelector('span').textContent = _t('view_all_js', {count: chip.dataset.count}); }
        upd();
      });
      if (code && sec.hasAttribute('data-f7-h-ad')) {
        var bar = sec.querySelector('[role="tablist"]');
        var chip = sec.querySelector('[data-tab][data-code="' + code + '"]');
        if (chip) {
          if (bar && bar.firstElementChild !== chip) bar.insertBefore(chip, bar.firstElementChild);
          select(chip);
        }
      }
    });
  }

  function clubs(){
    document.querySelectorAll('[data-f7-h-clubs]').forEach(function(sec){
      var input = sec.querySelector('[data-f7-h-club-search]');
      var results = sec.querySelector('[data-f7-h-results]');
      var empty = sec.querySelector('[data-f7-h-empty]');
      var tabsBar = sec.querySelector('.f7-h-clubs__tabs');
      var panels = sec.querySelectorAll('[data-f7-h-panel]');
      var current = 0;
      tabs(sec, function(i){ current = i; });
      sec.querySelectorAll('[data-f7-h-more]').forEach(function(b){
        b.addEventListener('click', function(){ b.closest('.f7-h-clubs__grid').classList.add('is-expanded'); });
      });
      if (!input) return;
      var all = Array.prototype.slice.call(sec.querySelectorAll('[data-f7-h-panel] .f7-h-club'));
      input.addEventListener('input', function(){
        var q = norm(input.value);
        if (!q) {
          results.hidden = true; empty.hidden = true; tabsBar.hidden = false;
          panels.forEach(function(p, n){ p.hidden = n !== current; });
          return;
        }
        var seen = {};
        results.innerHTML = '';
        all.forEach(function(a){
          if (seen[a.href] || norm(a.dataset.name).indexOf(q) === -1) return;
          seen[a.href] = 1;
          var c = a.cloneNode(true); c.classList.remove('is-extra');
          results.appendChild(c);
        });
        tabsBar.hidden = true;
        panels.forEach(function(p){ p.hidden = true; });
        results.hidden = !results.children.length;
        empty.hidden = !!results.children.length;
      });
    });
  }

  /* Palavra da oferta que troca sozinha (para quando sai da tela) */
  function tickers(){
    document.querySelectorAll('[data-f7-h-ticker]').forEach(function(t){
      var words = t.querySelectorAll('.f7-h-ticker__word');
      if (words.length < 2 || reduce || !hasIO) return;
      var i = 0, timer = null;
      var step = function(){
        var cur = words[i]; i = (i + 1) % words.length; var nxt = words[i];
        cur.classList.remove('is-in'); cur.classList.add('is-out'); cur.setAttribute('aria-hidden', 'true');
        nxt.classList.remove('is-out'); nxt.classList.add('is-in'); nxt.removeAttribute('aria-hidden');
        setTimeout(function(){ cur.classList.remove('is-out'); }, 600);
      };
      new IntersectionObserver(function(es){
        es.forEach(function(e){
          if (e.isIntersecting && !timer) timer = setInterval(step, 2200);
          else if (!e.isIntersecting && timer) { clearInterval(timer); timer = null; }
        });
      }).observe(t);
    });
  }

  /* Ligas: carrossel + janela com as equipas da liga */
  function leagues(){
    document.querySelectorAll('[data-f7-h-leagues]').forEach(function(sec){
      var track = sec.querySelector('.f7-h-leagues__track');
      wireNav(sec, function(){ return track; });
      var dlg = sec.querySelector('[data-f7-h-lgm]'), body = sec.querySelector('[data-f7-h-lgm-body]');
      if (!dlg || typeof dlg.showModal !== 'function') return;
      var close = function(){ dlg.close(); };
      dlg.addEventListener('close', function(){ document.documentElement.classList.remove('f7-h-lock'); });
      dlg.addEventListener('click', function(e){ if (e.target === dlg) close(); });
      sec.querySelector('[data-f7-h-lgm-close]').addEventListener('click', close);
      sec.querySelectorAll('button[data-league]').forEach(function(card){
        card.addEventListener('click', function(){
          var tpl = sec.querySelector('template[data-league-tpl="' + card.dataset.league + '"]');
          if (!tpl) return;
          body.innerHTML = '';
          body.appendChild(tpl.content.cloneNode(true));
          fillNames(body);
          var title = body.querySelector('.f7-h-lgm__title');
          if (title) dlg.setAttribute('aria-label', title.textContent);
          document.documentElement.classList.add('f7-h-lock');
          dlg.showModal();
          body.scrollTop = 0;
        });
      });
    });
  }

  /* Acordeão suave e entrada escalonada (FAQ e vídeos) */
  function smooth(d){
    var s = d.querySelector(':scope > summary');
    var body = s && s.nextElementSibling;
    if (!s || !body || d.dataset.f7hSmooth) return;
    d.dataset.f7hSmooth = '1';
    s.addEventListener('click', function(e){
      if (reduce || !body.animate) return;
      e.preventDefault();
      var closing = d.classList.contains('is-closing');
      if (d._f7Anim) { d._f7Anim.cancel(); d._f7Anim = null; }
      d.classList.remove('is-closing');
      body.style.overflow = 'hidden';
      if (d.open && !closing) {
        d.classList.add('is-closing');
        d._f7Anim = body.animate([{height: body.offsetHeight + 'px', opacity: 1}, {height: '0px', opacity: 0}], {duration: 280, easing: 'cubic-bezier(.4,0,.2,1)'});
        d._f7Anim.onfinish = function(){ d.open = false; d.classList.remove('is-closing'); body.style.overflow = ''; d._f7Anim = null; };
      } else {
        d.open = true;
        d._f7Anim = body.animate([{height: '0px', opacity: 0}, {height: body.offsetHeight + 'px', opacity: 1}], {duration: 360, easing: 'cubic-bezier(.2,.8,.2,1)'});
        d._f7Anim.onfinish = function(){ body.style.overflow = ''; d._f7Anim = null; };
      }
    });
  }
  function expand(node){
    node.hidden = false;
    if (reduce || !node.animate) return;
    node.style.overflow = 'hidden';
    node.animate([{height: '0px', opacity: 0}, {height: node.offsetHeight + 'px', opacity: 1}], {duration: 460, easing: 'cubic-bezier(.2,.8,.2,1)'}).onfinish = function(){ node.style.overflow = ''; };
  }
  function collapse(node){
    if (reduce || !node.animate) { node.hidden = true; return; }
    node.style.overflow = 'hidden';
    node.animate([{height: node.offsetHeight + 'px', opacity: 1}, {height: '0px', opacity: 0}], {duration: 320, easing: 'cubic-bezier(.4,0,.2,1)'}).onfinish = function(){ node.hidden = true; node.style.overflow = ''; };
  }
  function armReveal(box){
    if (!box || reduce || !hasIO) return;
    var els = box.querySelectorAll('.f7-h-reveal');
    els.forEach(function(e, i){ e.style.setProperty('--i', i % 12); });
    box.classList.add('is-armed', 'is-f7-h-armed');
    var ro = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting) { en.target.classList.add('is-in'); ro.unobserve(en.target); } });
    }, {rootMargin: '0px 0px -8% 0px'});
    els.forEach(function(e){ ro.observe(e); });
  }
  function faq(){
    document.querySelectorAll('.f7-h-faq').forEach(function(sec){
      sec.querySelectorAll('details').forEach(smooth);
      var more = sec.querySelector('.f7-h-faq__more'), toggle = sec.querySelector('.f7-h-faq__toggle');
      if (more && toggle) {
        var label = toggle.querySelector('[data-label]'), count = toggle.querySelector('.f7-h-faq__toggle-count');
        toggle.addEventListener('click', function(){
          var open = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (open) { collapse(more); label.textContent = label.dataset.more; if (count) count.hidden = false; }
          else { expand(more); label.textContent = label.dataset.less; if (count) count.hidden = true; }
        });
      }
      armReveal(sec);
    });
  }
  function reviews(){
    document.querySelectorAll('.f7-h-reviews').forEach(function(sec){
      var track = sec.querySelector('[data-f7-h-rv-track]');
      var cards = sec.querySelectorAll('.f7-h-rv');
      cards.forEach(function(card){
        var v = card.querySelector('video');
        var media = card.querySelector('.f7-h-rv__media');
        var snd = card.querySelector('.f7-h-rv__sound');
        if (!v) { if (snd) snd.hidden = true; card.classList.remove('is-paused'); return; }
        v.muted = true; v.loop = true; v.playsInline = true; v.removeAttribute('controls');
        v.addEventListener('play', function(){ card.classList.remove('is-paused'); });
        v.addEventListener('pause', function(){ card.classList.add('is-paused'); });
        var toggle = function(){ if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function(){}); } else { v.pause(); } };
        media.addEventListener('click', function(e){ if (!e.target.closest('.f7-h-rv__sound')) toggle(); });
        media.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
        if (snd) snd.addEventListener('click', function(e){
          e.stopPropagation();
          var turnOn = v.muted;
          sec.querySelectorAll('.f7-h-rv').forEach(function(o){ var ov = o.querySelector('video'); if (ov) ov.muted = true; o.classList.remove('is-sound'); });
          v.muted = !turnOn;
          card.classList.toggle('is-sound', turnOn);
          snd.setAttribute('aria-label', turnOn ? _t('sound_off') : _t('sound_on'));
          if (turnOn) { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
        });
      });
      if (!reduce && hasIO) {
        var io = new IntersectionObserver(function(es){
          es.forEach(function(e){
            var v = e.target.querySelector('video');
            if (!v) return;
            if (e.intersectionRatio >= 0.6) { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
            else { v.pause(); }
          });
        }, {threshold: [0, 0.6]});
        cards.forEach(function(c){ io.observe(c); });
      }
      var map = teamMap();
      sec.querySelectorAll('.f7-h-rv__ptitle[data-handle]').forEach(function(t){
        var club = map[codeOf(t.dataset.handle)];
        if (club && t.textContent.indexOf(club) === -1) t.textContent = club + ' ' + t.textContent.trim();
      });
      if (track) wireNav(sec, function(){ return track; });
      armReveal(sec);
    });
  }

  /* Clube do anúncio: ?c=XXX (3 dígitos). O botão principal do hero passa a "Ver <clube>" e vai para a coleção do clube. */
  function adClub(){
    var m = /[?&]c=([0-9]{3})(?:&|$)/.exec(location.search);
    var code = m ? m[1] : '';
    if (!code || !teamMap()[code]) return '';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    document.querySelectorAll('[data-f7-h-hero-cta]').forEach(function(a){
      a.href = root + 'collections/' + code;
      var lbl = a.querySelector('[data-f7-h-cta-label]');
      if (lbl) lbl.textContent = _t('see_club', {name: teamMap()[code]});
    });
    return code;
  }

  /* Criança: a família em palitinho anima quando a secção entra na tela */
  function kids(){
    document.querySelectorAll('.f7-h-kids').forEach(function(sec){
      if (!hasIO) { sec.classList.add('is-in'); return; }
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){ if (e.isIntersecting) { sec.classList.add('is-in'); io.disconnect(); } });
      }, {threshold: 0.2});
      io.observe(sec);
    });
  }

  function heroWatch(){
    var hero = document.querySelector('.f7-h-hero');
    if (!hero || !hasIO) return;
    new IntersectionObserver(function(es){ document.body.classList.toggle('f7-hero-in', es[0].isIntersecting); }, {threshold: 0.35}).observe(hero);
  }
  function init(){ heroWatch(); var code = adClub(); fillNames(document); rails(code); clubs(); tickers(); leagues(); faq(); reviews(); kids(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
